import React, { useState } from 'react';
import { Checkbox, FormControl, Grid, Select, TextField, SelectChangeEvent, MenuItem } from '@mui/material';
import { Feedback } from '../../store/tasks/types';
import FeedbackTypes from '../../resources/enums/FeedbackTypes';
import { FeedbackProps } from './types';
import './Feedback.scss';

const TaskFeedback: React.FC<FeedbackProps> = (props) => {
    const [disabled, setDisabled] = useState<boolean>(props.task.feedback?.type == null);
    const [type, setType] = useState<string>(props.task.feedback?.type ?? FeedbackTypes.Positive);
    const getSelectOptions = () => {
        return Object.entries(FeedbackTypes).map((item, index) => {
            return (
                <MenuItem key={index} value={item[1]}>
                    {item[0]}
                </MenuItem>
            );
        });
    };
    const handleChangeCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = event.target.checked;
        if (!isChecked) {
            props.setTasks(
                props.tasks.map((item) => {
                    return item.id !== props.task.id
                        ? item
                        : {
                              ...props.task,
                              feedback: {} as Feedback,
                          };
                }),
            );
        } else {
            props.setTasks(
                props.tasks.map((item) => {
                    return item.id !== props.task.id
                        ? item
                        : {
                              ...props.task,
                              feedback: { type: FeedbackTypes.Positive } as Feedback,
                          };
                }),
            );
        }
        setDisabled(!isChecked);
    };
    const handleChangeTextFeedback = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        props.setTasks(
            props.tasks.map((item) => {
                return item.id !== props.task.id
                    ? item
                    : {
                          ...props.task,
                          feedback: {
                              ...props.task.feedback,
                              text: { ...props.task.feedback?.text, [props.language]: e.target.value },
                              type: type,
                          } as Feedback,
                      };
            }),
        );
    };
    const handleChangeType = (e: SelectChangeEvent) => {
        setType(e.target.value);
        props.setTasks(
            props.tasks.map((item) => {
                return item.id !== props.task.id
                    ? item
                    : {
                          ...props.task,
                          feedback: {
                              ...props.task.feedback,
                              type: type,
                          } as Feedback,
                      };
            }),
        );
    };
    return (
        <div>
            <Grid container spacing={2} className="feedback-row">
                <Grid item xs={1}>
                    <Checkbox
                        onChange={handleChangeCheckbox}
                        checked={!disabled}
                        sx={{ '& .MuiSvgIcon-root': { fontSize: '2.4rem' } }}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormControl className="task-type-selector">
                        <Select disabled={disabled} onChange={handleChangeType} value={type}>
                            {getSelectOptions()}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={9}>
                    {props.languages.map((lang) => (
                        <TextField
                            fullWidth
                            key={`feedback_${lang.code}`}
                            id={`feedback_${lang.code}`}
                            name={`feedback_${lang.code}`}
                            style={{ display: lang.code === props.language ? 'block' : 'none' }}
                            defaultValue={props.task.feedback?.text?.[lang.code]}
                            variant="outlined"
                            required={false}
                            type="text"
                            label="Feedback"
                            onChange={handleChangeTextFeedback}
                            disabled={disabled}
                        ></TextField>
                    ))}
                </Grid>
            </Grid>
        </div>
    );
};

export default TaskFeedback;
